// extracted by mini-css-extract-plugin
export default {"connectToServiceFallback":"IbhC2cbOcXCe50IsgPlj","title":"RhTgALYQqbyRXahoaM1r","description":"eF9A1ERtm1OSvS1yvDPA"};